import { render } from "./register.vue?vue&type=template&id=510b2a6e&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=510b2a6e&scoped=true&lang=css"
import "./register.vue?vue&type=style&index=1&id=510b2a6e&lang=scss"
script.render = render
script.__scopeId = "data-v-510b2a6e"

export default script